














































import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import moment from 'moment';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import DateFormat from '@/shared/utils/date-format';
import Datasource from '@/domain/business-unit/entity/datasource.entity';
import VariableMetadata from '@/domain/business-unit/entity/variable-metadata.entity';
import RuleScriptParameter from '@/domain/scripts/entity/rule-script-parameter.entity';
import RuleVariablesService from '@/domain/scripts/service/rule-variables.service';
import { renderJsonHtml } from '@/shared/utils/json-html-helper';
import DataSourceField from './data-source-field.component.vue';

@Component({
  components: { DataSourceField },
})
export default class DataDictionaryPanel extends Vue {
  @Prop({ required: true }) businessUnitId!: string;

  @Prop({ default: null }) dataSourceId!: string | null;

  @Prop({ default: false }) previewModeValue!: boolean;

  @Prop({ default: () => [] }) parameters!: RuleScriptParameter[];

  consumptionVariables: VariableMetadata[] = [];

  dataSources: Datasource[] = [];

  loading: boolean = false;

  renderJsonHtml = renderJsonHtml;

  created() {
    this.loadDataSources();
    this.loadVariables();
  }

  @Watch('dataSourceId')
  onDataSourceIdChange() {
    this.loadVariables();
  }

  get fixedParameters(): RuleScriptParameter[] {
    return this.parameters;
  }

  get selectedDataSource(): Datasource | null {
    return this.dataSources.find((d: Datasource) => d.id === this.dataSourceId) || null;
  }

  get rawVariablesJson(): Array<{ name: string; type: string; sample: string | null }> {
    return this.consumptionVariables.map((variable) => ({
      name: variable.name,
      type: variable.type,
      sample: variable.sample,
    }));
  }

  get updatedAtText(): string {
    const source = this.selectedDataSource;
    const updatedAt = source ? source.variablesMetadataUpdatedAt : null;
    if (!updatedAt) {
      return 'nunca atualizado';
    }
    const date = DateFormat.timestampToLocal(moment(updatedAt).format('YYYY-MM-DD'));
    const time = moment(updatedAt).format('HH:mm');
    return `atualizado em ${date} ${time} · gerado a partir de 1 instância de amostra`;
  }

  loadDataSources() {
    RuleVariablesService.listDataSources(this.businessUnitId)
      .then((dataSources: Datasource[]) => {
        this.dataSources = dataSources;
      }).catch((err: any) => VbSnackbarService.handleHttpError(err));
  }

  loadVariables() {
    if (!this.dataSourceId) {
      this.consumptionVariables = [];
      return;
    }

    this.loading = true;
    RuleVariablesService.getVariables(this.businessUnitId, this.dataSourceId)
      .then((variables: VariableMetadata[]) => {
        this.consumptionVariables = variables;
      })
      .catch((err: any) => VbSnackbarService.handleHttpError(err))
      .finally(() => { this.loading = false; });
  }

  reload() {
    this.loadDataSources();
    this.loadVariables();
  }
}
